 document.addEventListener("DOMContentLoaded", () => {
  $(document).on("click", ".select_flavors_button button", async function () {
      $(this).addClass("animation_active");
      $("body.redirect_checkout").addClass("notshowss");

      setTimeout(function () {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            detail: {
              data: {},
            },
          })
        );
      }, 2500);
      
      setTimeout(function () {
        document.querySelector("cart-drawer-component").open()
      }, 3500);
      await itemadded();
    });

   


$(document).on("click",".gp-justify-start.variant-option-group label",function () {
    setTimeout(function () {
      var idd = $('product-form.product-form form input[name="id"]').val();
      $('.gift-blocks.my_gifts[data-id="' + idd + '"]').addClass("active");
      $('.gift-blocks.my_gifts[data-id!="' + idd + '"]').removeClass("active");
      $(".select_flavors_button button").attr("data-vall", idd);
    }, 500);
  }
);

$(document).ready(function () {
  setTimeout(function () {
    var idd = $('product-form.product-form form input[name="id"]').val();
    $(".select_flavors_button button").attr("data-vall", idd);
    $('.gift-blocks.my_gifts[data-id="' + idd + '"]').addClass("active");
  }, 1000);
});
function getQuantityByVariantId(cartData, variantId) {
  const item = cartData.items.find(
    (item) => item.variant_id === variantId
  );

  return item ? item.quantity : 0;
}


function itemadded() {

  const mainVariantId = $('product-form.product-form form input[name="id"]').val();
  let itemsToAdd = [];

  $.getJSON('/cart.js', function(cart) {
    //Check if any free gift already exists
    let giftAlreadyInCart = cart.items.some(item =>
      item.properties && item.properties.Order === "Gift pack"
    );

    // Add free gifts ONLY if not already in cart
    if (!giftAlreadyInCart) {
      $('.gift_card_section .gift-blocks.my_gifts.active .gift_card_body.is-active')
        .not('.out-of-stock')
        .each(function () {
          itemsToAdd.push({
            id: $(this).attr('variant_id'),
            quantity: 1,
            properties: { Order: 'Gift pack' }
          });
        });
    }

    //Main product → always add (Shopify qty auto increase)
    itemsToAdd.push({
      id: mainVariantId,
      quantity: 1,
      properties: { Buy: "With Gifts" }
    });

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify({ items: itemsToAdd }),
      contentType: 'application/json',
      success: function () {
        if ($('body').hasClass('redirect_checkout')) {
          window.location = '/checkout';
        }
      },
      error: function () {
        alert('Cart update failed');
      }
    });

  });
}

document.addEventListener('click', function (e) {
  if (!e.target.closest('.cart-items__remove')) return;
  setTimeout(function () {

    $.getJSON('/cart.js', function (cart) {

      // Check: If  product (Buy: With Gifts) exist
      let mainProductExists = cart.items.some(item =>
        item.properties && item.properties.Buy === "With Gifts"
      );

      // If  product does not remove 
      if (!mainProductExists) {

        let updates = {};

        cart.items.forEach(item => {
          if (item.properties && item.properties.Order === "Gift pack") {
            updates[item.key] = 0;
          }
        });

        // Gift Product → remove 
        if (Object.keys(updates).length > 0) {
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: JSON.stringify({ updates }),
            contentType: 'application/json',
            success: function () {
              console.log('working');
              // document.dispatchEvent(new CustomEvent('cart:update'));
               document.dispatchEvent(
                  new CustomEvent('cart:update', {
                    detail: {
                      data: {},
                    },
                  })
                );
            }
          });
        }
      }
    });

  }, 1000); // cart update wait
});

// async function cartClear() {
//   $.getJSON("/cart", function (cart) {
//     var updates = {};
//     var handle = $(".variants_data_product").attr("data-handle");
//     var ittt = cart.items.find((x) => x.handle == handle);
//     if (ittt) {
//       var main_id = ittt.id;
//       updates[main_id] = 0;
//     }
//     for (var i = 0; i < cart.items.length; i++) {
//       if (
//         cart.items[i].properties &&
//         cart.items[i].properties.Order === "Gift pack"
//       ) {
//         var idd = cart.items[i].id;
//         updates[idd] = 0;
//       }
//     }
//     $.ajax({
//       type: "POST",
//       url: "/cart/update.js",
//       data: JSON.stringify({ updates: updates }),
//       contentType: "application/json",
//       dataType: "json",
//       success: function (data) {
//         console.log("Removed items succesfully:", data);
//       },
//       error: function (err) {
//         console.error("Error removing item:", err);
//       },
//     });
//   });
// }


var myInterval = setInterval(function () {
  var aa = $(".my_content_feature").html();
  $("product-form.product-form .gift_card_section").html(aa);
  if ($("product-form.product-form .gift_card_section").length) {
    clearInterval(myInterval);
  }
}, 300);


});